<button
  appThrottleClick
  (throttleClick)="backClicked.emit()"
  [style.padding-bottom.rem]="paddingBottomRem"
  class="back-button">
  <img [src]="'assets/icons/dark/Left Chevron.svg'" />
  <ng-container i18n>Back</ng-container>
</button>
